import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import GeneralOfferForm from 'components/GeneralOfferForm/GeneralOfferForm';
import PublishForm from 'components/PublishForm/PublishForm';
import PushNotificationForm from 'components/PushNotificationForm/PushNotificationForm';
import postApi from 'utils/api/post/PostApi';
import { Row, Col, message } from 'antd';
import './GeneralOfferFormContainer.less';
import '../styles/FormCommon.less';

const GeneralOfferFormContainer = (props) => {
  const { location, token } = props;
  const locationPath = location.pathname.split('/');
  const [data, setData] = useState({});
  const [pushNotificationData, setPushNotificationData] = useState({
    error: false,
  });
  const [postToEdit, setPostToEdit] = useState({
    data: {},
    render: !!locationPath[2],
  });

  /**
   * Method to get post byId
   * @param id
   * @returns {Promise<>}
   */
  const getPostById = async (id) => {
    try {
      const response = await postApi.getPost(id, token);
      if (response.status === 200) {
        setPostToEdit({
          data: response.data,
          render: true,
        });
      }
    } catch (err) {
      message.error(err.toString());
    }
  };

  /**
   * UseEffect to get the data.
   */
  useEffect(() => {
    if (locationPath[2]) {
      getPostById(locationPath[2]);
    }
  }, []);

  /**
   * TODO: Need to valid with GI
   * UseEfect to reset the hook if the user after click to edit click again on
   * Oferta General sider button
   */
  useEffect(() => {
    if (!locationPath[2] && postToEdit.render) {
      setPostToEdit({ render: false, data: {} });
      setData({});
    }
  }, [location]);

  /**
   * UseEfect to reset the hook if the user change the form
   */
  useEffect(() => {
    // If push notification has info
    if (pushNotificationData.content) {
      // Join the info
      const tempData = data;
      tempData.push_notification = { ...pushNotificationData };
      setData(tempData);
    } else if (data.push_notification) {
      // Remove the push_notification data.
      delete data.push_notification;
    }
  }, [data, pushNotificationData]);

  /**
   * Method for the submit
   * @param values
   */
  const handleGeneralOffer = (values) => {
    // Send the json to the publish form too
    setData(values);
  };

  const handlePushNotificationData = (values) => {
    setPushNotificationData(values);
  };

  return (
    <div className="general-offer-form-content">
      <div className="general-offer-form">
        <Row gutter={20}>
          <Col span={16}>
            <div className="general-offer-form-header">
              <h2 className="form-title">Información General</h2>
            </div>
            <GeneralOfferForm
              handleRequest={handleGeneralOffer}
              data={postToEdit.data}
              token={token}
              renderToEdit={postToEdit.render}
              nested
            />
          </Col>
          <Col span={7}>
            <div className="general-offer-sider">
              <PublishForm
                offerType="Oferta General"
                data={data}
                postToEdit={postToEdit}
              />
            </div>
          </Col>
        </Row>
        <Row gutter={20}>
          <PushNotificationForm
            handleRequest={handlePushNotificationData}
            pushNotificationData={postToEdit.data.push_notification}
          />
        </Row>
      </div>
    </div>
  );
};

GeneralOfferFormContainer.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  location: PropTypes.object.isRequired,
  token: PropTypes.string.isRequired,
};


export default withRouter(GeneralOfferFormContainer);
